<template>
  <AuthLayout>
    <form @submit.prevent="auth">
      <div class="login-form__title">Bienvenido de nuevo</div>
      <div class="login-form__subtitle">Ingresá tus credenciales para acceder al panel de gestión.</div>

      <div class="login-form__fields">
        <div v-if="login_error != ''" class="login-form__error">Los datos ingresados son incorrectos. Vuelve a intentarlo</div>

        <div>
          <label for="login-email" class="login-form__label">Email</label>
          <input id="login-email" v-model="email" type="text" class="login-form__input" placeholder="nombre@empresa.com" autocomplete="username" required />
        </div>

        <div>
          <label for="login-password" class="login-form__label">Contraseña</label>
          <div class="login-form__password">
            <input
              id="login-password"
              v-model="password"
              :type="show ? 'text' : 'password'"
              class="login-form__input"
              placeholder="••••••••"
              autocomplete="current-password"
              required
            />
            <button type="button" class="login-form__toggle" :aria-label="show ? 'Ocultar contraseña' : 'Mostrar contraseña'" @click="show = !show">
              <v-icon small>{{ show ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
            </button>
          </div>
        </div>

        <button type="submit" class="login-form__submit" :disabled="loading">{{ loading ? "Ingresando..." : "Iniciar sesión" }}</button>
      </div>
    </form>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/AuthLayout.vue";
import { authService } from "@/libs/ws/authService";
import Constant from "@/constants/sections";
export default {
  name: "App",

  components: { AuthLayout },

  data: () => ({
    login_error: "",
    email: "",
    password: "",
    show: false,
    loading: false,
  }),

  methods: {
    auth: function (event) {
      this.loading = true;
      authService
        .login(this.email, this.password)
        .then((response) => {
          if (!response.status) {
            this.login_error = response.msg;
          } else {
            localStorage.setItem("token", response.result.token);
            localStorage.setItem("expire_in", response.result.expire_in);
            localStorage.setItem("email", response.result.email);
            localStorage.setItem("name", response.result.name);
            const encryptedText = this.CryptoJS.AES.encrypt(JSON.stringify(response.result.access), Constant.SECRET_PHRASE).toString();

            localStorage.setItem("access", encryptedText);
            localStorage.setItem("user_type", response.result.user_type);
            localStorage.setItem("company_user_id", response.result.company_user_id);
            localStorage.setItem("app_object", JSON.stringify(response.result.app_object)); //Representa el id segun el tipo de usuario: Client o Employee
            localStorage.setItem("settings", JSON.stringify(response.result.settings));
            localStorage.setItem("must_change_password", response.result.must_change_password ? "true" : "false");
            //this.$router.go("/"); NO FUNCIONA EN SAFARI
            window.location.reload();
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
};
</script>
